<mat-tab-group class="distribute-members"
  [selectedIndex]="selectedIndex"
  appScrollRetainer
  *ngIf="visitInfo$ | async as visitInfo">
  <mat-tab [label]="'DISTRIBUTE.sessions' | translate">
    <app-sessions-tab [visitInfo]="visitInfo"
      [userRole]="userRole$ | async"
      [data]="data"
      (isValid)="sessionChanged($event)"
      [disabled]="disabled"
      [viewOnly]="viewOnly"></app-sessions-tab>
  </mat-tab>
  <mat-tab [label]="'DISTRIBUTE.criterions' | translate">
    <app-criterions-tab [visitInfo]="visitInfo"
      [userRole]="userRole$ | async"
      [data]="data"
      (isValid)="criterionsChanged($event)"
      [disabled]="disabled"
      [viewOnly]="viewOnly"></app-criterions-tab>
  </mat-tab>
</mat-tab-group>
